import { Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { ItemWithID, MenuDivider } from '@sb/library/base';

@Component({
    selector: 'lib-input-select-item',
    templateUrl: './form-field-select-item.component.html',
})
export class FormFieldSelectItemComponent<T extends ItemWithID | string> {

    @Input() value!: T;
    @Input() menuDivider: MenuDivider = MenuDivider.None;
    @Input() qaTag: string = "";

    @ViewChild('selectLabel', {static: true, read: TemplateRef}) selectLabel!: TemplateRef<any>;
    @ViewChild('selectSupportingText', {static: true, read: TemplateRef}) selectSupportingText!: TemplateRef<any>;

    group: IItemGroup | null = null;
}

export interface IItemGroup {
    name: string;
}
